import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import HomeIcon from '@material-ui/icons/Home';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import PaymentIcon from '@material-ui/icons/Payment';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ClassIcon from '@material-ui/icons/Class';
import PeopleIcon from '@material-ui/icons/People';
import SecurityIcon from '@material-ui/icons/Security';
import AssessmentIcon from '@material-ui/icons/Assessment';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ListSubheader from '@material-ui/core/ListSubheader/ListSubheader';
import List from '@material-ui/core/List/List';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import type { Location, RouterHistory } from 'react-router';
import { get } from '../../utility';
import { ROLE_ID } from '../../constants';
import { withAppUser } from '../../shared/authorization/userConsumer';

import LogoSmall from '../../assets/real-sign-small.svg';
import Logo from '../../assets/real-sign.svg';

import styles from './drawer.styles';

function isSuperAdmin(user) {
  if (!user) return false;
  const nodes = get(user, 'systemAclsByUserId.nodes', []);
  return nodes.some(acl => Number(acl.roleId) === ROLE_ID.SUPER_ADMIN);
}

type PropType = {
  classes: Object,
  theme: Object,
  handleToggleDrawer: () => void,
  open: boolean,
  history: RouterHistory,
  location: Location,
  user: Object,
};

function DrawerC({
  classes,
  theme,
  history,
  open,
  handleToggleDrawer,
  location,
  user,
}: PropType) {
  const superAdmin = isSuperAdmin(user);
  const themeDirectionOpen = theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />;
  const themeDirectionClosed = theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />;
  const themeLogo = theme.custom === 'dt' ? (
    <div className={classes.header}>
      <Logo />
    </div>
  ) : (
    <div className={classes.header}>
      <Typography variant="caption" classes={{ root: classes.headerText }}>
          RealDesk Esign
      </Typography>
      <Typography variant="subheading" classes={{ root: classes.headerText }}>
          Admin Panel
      </Typography>
    </div>
  );

  const themeLogoSmall = theme.custom === 'dt' ? (
    <div className={classes.headerClosed}>
      <LogoSmall />
    </div>
  ) : (
    <div className={classes.headerClosed}>
      <Typography variant="caption" classes={{ root: classes.headerText }}>
          RealDesk Esign
      </Typography>
      <Typography variant="caption" classes={{ root: classes.headerText }}>
          Admin Panel
      </Typography>
    </div>
  );

  return (
    <div className={classes.root}>
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !open && classes.drawerPaperClose,
          ),
        }}
        open={open}
      >
        <div className={classes.drawerInner}>
          {open ? themeLogo : themeLogoSmall}
          <ListItem
            button
            disableGutters
            divider
            classes={{ root: classes.listItem, divider: classes.divider }}
            onClick={() => history.push('/admin')}
            selected={location.pathname === '/admin'}
          >
            <ListItemIcon classes={{ root: classes.listItemIcon }}>
              <HomeIcon />
            </ListItemIcon>
            {open && (
              <ListItemText
                classes={{
                  root: classes.listItemText,
                  primary: classes.listItemContent,
                }}
                primary="Dashboard"
              />
            )}
          </ListItem>
          <List
            component="nav"
            subheader={(
              <ListSubheader
                disableGutters
                component="div"
                className={classes.listSubheader}
              >
                {open ? 'Brokerage Management' : 'BM'}
              </ListSubheader>
)}
          >
            <ListItem
              classes={{ root: classes.listItem }}
              button
              disableGutters
              onClick={() => history.push('/admin/brokerage-management')}
              selected={location.pathname === '/admin/brokerage-management'}
            >
              <ListItemIcon classes={{ root: classes.listItemIcon }}>
                <LocationCityIcon />
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{
                    root: classes.listItemText,
                    primary: classes.listItemContent,
                  }}
                  primary="Brokerage Offices"
                />
              )}
            </ListItem>
            <ListItem
              classes={{ root: classes.listItem }}
              button
              disableGutters
              onClick={() => history.push('/admin/agent-management')}
              selected={location.pathname === '/admin/agent-management'}
            >
              <ListItemIcon classes={{ root: classes.listItemIcon }}>
                <AccountBoxIcon />
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{
                    root: classes.listItemText,
                    primary: classes.listItemContent,
                  }}
                  primary="Agents"
                />
              )}
            </ListItem>
            <ListItem
              button
              disableGutters
              divider
              classes={{ root: classes.listItem, divider: classes.divider }}
              selected={location.pathname === '/admin/admin-management'}
              onClick={() => history.push('/admin/admin-management')}
            >
              <ListItemIcon classes={{ root: classes.listItemIcon }}>
                <ContactPhoneIcon />
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{
                    root: classes.listItemText,
                    primary: classes.listItemContent,
                  }}
                  primary="Admins"
                />
              )}
            </ListItem>
            <ListItem
              button
              disableGutters
              divider
              classes={{ root: classes.listItem, divider: classes.divider }}
              onClick={() => history.push('/admin/partner-auth-csv')}
              selected={location.pathname === '/admin/partner-auth-csv'}
            >
              <ListItemIcon classes={{ root: classes.listItemIcon }}>
                <FileCopyIcon />
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{
                    root: classes.listItemText,
                    primary: classes.listItemContent,
                  }}
                  primary="Partner auth CSV"
                />
              )}
            </ListItem>
          </List>
          {superAdmin && (
            <List
              component="nav"
              subheader={(
                <ListSubheader
                  disableGutters
                  component="div"
                  className={classes.listSubheader}
                >
                  {open ? 'Reports' : 'R'}
                </ListSubheader>
)}
            >
              <ListItem
                classes={{ root: classes.listItem }}
                button
                disableGutters
                onClick={() => history.push('/admin/reports/expiring-subscriptions')}
                selected={location.pathname === '/admin/reports/expiring-subscriptions'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <AssessmentIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="Expiring subscriptions"
                  />
                )}
              </ListItem>
              <ListItem
                classes={{ root: classes.listItem }}
                button
                disableGutters
                onClick={() => history.push('/admin/reports/subscription-activity')}
                selected={location.pathname === '/admin/reports/subscription-activity'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <AssessmentIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="Subscription activity"
                  />
                )}
              </ListItem>
            </List>
          )}
          {superAdmin && (
            <List
              component="nav"
              subheader={(
                <ListSubheader
                  disableGutters
                  component="div"
                  className={classes.listSubheader}
                >
                  {open ? 'Super Admin' : 'SA'}
                </ListSubheader>
)}
            >
              <ListItem
                classes={{ root: classes.listItem }}
                button
                disableGutters
                onClick={() => history.push('/admin/subscriptions')}
                selected={location.pathname === '/admin/subscriptions'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <PaymentIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="Subscriptions"
                  />
                )}
              </ListItem>
              <ListItem
                classes={{ root: classes.listItem }}
                button
                disableGutters
                onClick={() => history.push('/admin/invites')}
                selected={location.pathname === '/admin/invites'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <PeopleIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="Invites"
                  />
                )}
              </ListItem>
              <ListItem
                classes={{ root: classes.listItem }}
                button
                disableGutters
                onClick={() => history.push('/admin/roles')}
                selected={location.pathname === '/admin/roles'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <ClassIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="Roles"
                  />
                )}
              </ListItem>
              <ListItem
                button
                disableGutters
                divider
                classes={{ root: classes.listItem, divider: classes.divider }}
                onClick={() => history.push('/admin/system-acls')}
                selected={location.pathname === '/admin/system-acls'}
              >
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                  <SecurityIcon />
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{
                      root: classes.listItemText,
                      primary: classes.listItemContent,
                    }}
                    primary="System ACLs"
                  />
                )}
              </ListItem>
            </List>
          )}
          <ListItem
            classes={{ root: classes.listItem }}
            button
            disableGutters
            onClick={handleToggleDrawer}
          >
            <ListItemIcon classes={{ root: classes.listItemIcon }}>
              {open ? themeDirectionOpen : themeDirectionClosed}
            </ListItemIcon>
            {open && (
              <ListItemText
                classes={{
                  root: classes.listItemText,
                  primary: classes.listItemContent,
                }}
                primary="Hide Drawer"
              />
            )}
          </ListItem>
        </div>
      </Drawer>
    </div>
  );
}

export default compose(
  withStyles(styles, { withTheme: true }),
  withAppUser,
  withRouter,
)(DrawerC);
